import { FC } from 'react';

import { LeadTestID } from '../../test-ids';
import { HeadingSkeleton, InputSkeleton, SubmitSkeleton } from './LeadFormSkeleton.styles';

export const LeadFormSkeleton: FC = () => {
    return (
        <div data-test={LeadTestID.LEAD_FORM_SKELETON}>
            <HeadingSkeleton />
            <InputSkeleton />
            <InputSkeleton />
            <InputSkeleton />
            <SubmitSkeleton />
        </div>
    );
};
